import * as React from 'react'
import BasicDataStage from './BasicDataStage'
import TachographStage from './TachographStage'
import DatesStage from './DatesStage'
import GroupsStage from './GroupsStage'
import { Divider } from '../shared/Divider'

const VehicleBasicForm = () => {
  return (
    <section className="tw-space-y-6 tw-p-6">
      <BasicDataStage />
      <Divider />
      <TachographStage />
      <Divider />
      <DatesStage />
      <Divider />
      <GroupsStage />
    </section>
  )
}

export default VehicleBasicForm

